<uni-section>
    <uni-title-container>
        <uni-title-item>
                <a [routerLink]="['/', 'insights', 'reports']"><i class="fa fa-chevron-left"></i></a>
                {{'ci.reports.createReport' | translate}}
        </uni-title-item>
    </uni-title-container>
</uni-section>
<uni-section>

<app-create-form></app-create-form>